import { UserInfoVisibility } from '../types';

/** Default visibility of the member-info column rows (used pre-hydration and as hydration fallback) */
export const DEFAULT_USER_INFO_VISIBILITY: UserInfoVisibility = {
  isManager: true,
  memberManager: false,
  department: true,
  role: true,
  seniority: true,
  location: true,
  capacityPerDay: true,
  billableCapacity: true,
  membershipType: false,
  customAttributes: {},
};
